import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoFacebook = () => {
  return (
    <g>
      <path d="m8.89 4.5583v-1.1128c0-.64.5731-.8688 1.2133-.8688a5.56 5.56 0 0 1 1.326.1982l.4118-2.4388a10.3689 10.3689 0 0 0 -2.9511-.2961 2.9276 2.9276 0 0 0 -2.5546 1.1985 4.2757 4.2757 0 0 0 -.53 2.4662v1.6h-1.6465v2.3813h1.6462v8.274h3.0849v-8.2741h2.4417l.1829-2.3808h-2.6246z" />
    </g>
  );
};

export default withIcon(IconLogoFacebook);
